const BASE_HOST = process.env.REACT_APP_BASE_HOST

if (!BASE_HOST || BASE_HOST === '') {
  throw Error('unknown base host')
}

const development = {
  ENV: 'developemnt',
  API_URL: 'http://localhost:3000',
  APP_URL: 'http://localhost:3000',
  CATALOG_URL: 'http://localhost:3000',
  SELECTION_URL: 'http://localhost:3000',
  DISABLE_ROLLBAR: true,
  ROLLBAR_TOKEN: 'd9ef4eed6df1473c93b5212ddf79e0d2',
};

interface TConfig {
  ENV: string
  API_URL: string
  CATALOG_URL: string
  APP_URL: string
  SELECTION_URL: string
  ROLLBAR_TOKEN: string
  DISABLE_ROLLBAR: boolean
}

const Config = ((env): TConfig => {
  switch (env) {
    case 'production':
      return {
        ENV: 'production',
        API_URL: `https://api.${BASE_HOST}/api`,
        CATALOG_URL: `https://catalog.${BASE_HOST}`,
        APP_URL: `https://web.${BASE_HOST}`,
        SELECTION_URL: `https://selection.${BASE_HOST}`,
        ROLLBAR_TOKEN: 'd9ef4eed6df1473c93b5212ddf79e0d2',
        DISABLE_ROLLBAR: false,
      };
    case 'staging':
      return {
        ENV: 'staging',
        API_URL: `https://api.${BASE_HOST}/api`,
        CATALOG_URL: `https://catalog.${BASE_HOST}`,
        APP_URL: `https://web.${BASE_HOST}`,
        SELECTION_URL: `https://selection.${BASE_HOST}`,
        DISABLE_ROLLBAR: false,
        ROLLBAR_TOKEN: 'd9ef4eed6df1473c93b5212ddf79e0d2',
      };
    default:
      return development;
  }
})(process.env.REACT_APP_ENV || process.env.NODE_ENV);

export default Config;
